import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgNiacinamideGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M32.63 16.94a1.419 1.419 0 1 0 .002-2.838 1.419 1.419 0 0 0-.002 2.838ZM39.25 38.5h-5.87V24c0-.41-.34-.75-.75-.75h-9.89V8.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75v26.89L9.44 8.45a.736.736 0 0 0-.84-.43.74.74 0 0 0-.6.73v30.5c0 .41.34.75.75.75s.75-.34.75-.75V12.36l11.8 27.19c.12.28.4.45.69.45.05 0 .1 0 .15-.02.35-.07.6-.38.6-.73v-14.5h9.14V38.5h-5.87c-.41 0-.75.34-.75.75s.34.75.75.75h13.24c.41 0 .75-.34.75-.75s-.34-.75-.75-.75Z",
    fill: "currentColor"
  }));
}

export { SvgNiacinamideGlyphSecondary as default };
